import React, { Component } from "react";
import AmericaItems from "./AmericaItems";
import { Route, Switch } from "react-router-dom";
import ItemInfo from '../ItemInfo'
import america from '../America'

export default class America extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const americaData = america.map(item => item)
    return (
      <React.Fragment>
        
        <Switch>
          <Route exact path="/america" component={AmericaItems} />
          <Route path={americaData.link} component={ItemInfo}/>
        </Switch>
      </React.Fragment>
    );
  }
}
